import React, { useState, useEffect } from 'react';
import './dechargerecomandation.css';
import Administration from './administration';
import Procedure from './procedure';
import { useParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import api from '../../service/caller';
import { jsPDF } from 'jspdf';
import { useNavigate } from 'react-router-dom';
import html2canvas from 'html2canvas';
import html2pdf from 'html2pdf.js';

function SuiviPostSortie({ onNext, onBack, patientData }) {


   const [admissionData, setAdmission] = useState(null);
   const [dischargeData, setDischarge] = useState(null);
       const [medicationData, setMedicationData] = useState([]);
       const [isLoading, setIsLoading] = useState(false);
   
       useEffect(() => {
        console.log("adata", patientData)
           const fetchAdmissionData = async () => {
               if (!patientData?._id) return;
   
               try {
                   const response = await api.get(`api/rooms/hospitalization/details/${patientData._id}`);
                   setAdmission(response.data.data);
                   const response2 = await api.get(`api/discharge/${patientData._id}`);
                   setDischarge(response2.data.data);
                   console.log('med', response.data.data);
               } catch (error) {
                //    toast.error("Failed to fetch data");
               }
           };
   
           fetchAdmissionData();
       }, [patientData?._id]);
   
       if (!patientData) {
           return (
               <div className="frame">
                   <h1 className="header">Aucun dossier patient sélectionné</h1>
                   <button className="btn back" onClick={onBack}>Retour</button>
               </div>
           );
       }
       if (!admissionData) {
           return <p>Chargement...</p>;
       }
   
       const { treatmentPlan } = admissionData;
   
       const formatDate = (dateString) => new Date(dateString).toLocaleDateString();
       const stayDays = patientData?.admissionDate
           ? Math.max(1, Math.ceil(
               (new Date() - new Date(patientData.admissionDate)) / (1000 * 60 * 60 * 24)
           ))
           : 1;
   
       const handleMedicationChange = (medicationRows) => {
           setMedicationData(medicationRows);
       };
       const handlePrint = () => {
        const element = document.querySelector('.modern-dossier');
        if (!element) return;
      
        setIsLoading(true); // Activer le loader
      
        try {
          const clone = element.cloneNode(true);
      
          // Exclure les éléments indésirables
          clone.querySelectorAll('.exclude-from-pdf').forEach(el => el.remove());
      
          const options = {
            margin: 1,
            filename: `Dossier_${patientData.patientId?.lastname}.pdf`,
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2, scrollY: -window.scrollY },
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
          };
      
          // Générer le PDF et désactiver le loader après la sauvegarde
          html2pdf()
            .set(options)
            .from(clone)
            .save()
            .then(() => {
              setIsLoading(false); // Désactiver le loader après le téléchargement
            });
        } catch (error) {
          console.error("Erreur lors de la génération du PDF:", error);
          toast.error("Erreur lors de la génération du PDF");
          setIsLoading(false); // Désactiver le loader en cas d'erreur
        }
      };
   
       return (
           <>
               <ToastContainer />
   
               <div className="pd-container modern-dossier">
                    <div className="pd-header-actions">
                        <button className="pd-back-button" onClick={() => onNext(1)}>
                        <span>← Retour</span>
                        </button>
                        <button 
                        onClick={handlePrint} 
                        disabled={isLoading}
                        className="btn btn-primary position-relative exclude-from-pdf"
                        >
                        {isLoading ? (
                            <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Génération...
                            </>
                        ) : (
                            "Exporter en PDF"
                        )}
                        </button>
                    </div>

                    {/* Section des informations patient */}
                    <div className="pd-section">
                        <div className="pd-section-header">
                        <span className="pd-indicator"></span>
                        <h3 className="pd-section-title">Patient Details</h3>
                        </div>
                    
                        <div className="pd-patient-details">
                        <div className="pd-detail-item">
                            <label>Nom :</label>
                            <p>{patientData.patientId?.lastname || 'N/A'}</p>
                        </div>
                        <div className="pd-detail-item">
                            <label>Prénom :</label>
                            <p>{patientData.patientId?.firstname || 'N/A'}</p>
                        </div>
                        <div className="pd-detail-item">
                            <label>Date of birth :</label>
                            <p>{formatDate(patientData.patientId?.age)}</p>
                        </div>
                        <div className="pd-detail-item">
                            <label>Address :</label>
                            <p>{patientData.patientId?.address || 'N/A'}</p>
                        </div>
                        <div className="pd-detail-item">
                            <label>Gender :</label>
                            <p>{patientData.patientId?.gender || 'N/A'}</p>
                        </div>
                        </div>
                    </div>

                    {/* Section du lit assigné */}
                    <div className="pd-section">
                        <div className="pd-section-header">
                        <span className="pd-indicator"></span>
                        <h3 className="pd-section-title">Room & Bed Assignment</h3>
                        </div>
                        
                        <div className="pd-bed-assignment">
                        <div className="pd-detail-item">
                            <label>Room Assigned</label>
                            <p>{patientData.roomId?.roomNumber || 'N/A'}</p>
                        </div>
                        <div className="pd-detail-item">
                            <label>Bed Assigned</label>
                            <p className="pd-bed-display">
                            <span className="pd-bed-icon">🛏️</span> 
                            {patientData.bedNumber || 'N/A'}
                            </p>
                        </div>
                        <div className="pd-detail-item">
                            <label>Assign Date</label>
                            <p>{formatDate(patientData.admissionDate)}</p>
                        </div>
                        </div>
                    </div>

                    {/* Section des détails d'hospitalisation */}
                    <div className="pd-section">
                        <div className="pd-section-header">
                        <span className="pd-indicator"></span>
                        <h3 className="pd-section-title">About Hospitalisation</h3>
                        </div>
                    
                        <div className="pd-hospitalization">
                        <div className="pd-detail-row">
                            <strong>Duration : </strong>
                            <span>{stayDays} day(s)</span>
                        </div>
                        <div className="pd-detail-row">
                            <strong>Note: </strong>
                            <span>{patientData.note || 'N/A'}</span>
                        </div>
                        </div>
                    </div>

                    {/* Section de traitement */}
                    {treatmentPlan && (
                        <div className="pd-section">
                        <div className="pd-section-header">
                            <span className="pd-indicator"></span>
                            <h3 className="pd-section-title">Treatment</h3>
                        </div>
                        
                        <div className="pd-treatment">
                            <div className="pd-detail-row">
                            <strong>Status : </strong>
                            <span>{treatmentPlan?.status || 'N/A'}</span>
                            </div>
                            <div className="pd-detail-row">
                            <strong>Note : </strong>
                            <span>{treatmentPlan?.notes || 'N/A'}</span>
                            </div>
                            <div className="pd-detail-row">
                            <strong>Follow Up Date : </strong>
                            <span>{formatDate(treatmentPlan?.followUpDate)}</span>
                            </div>
                        </div>

                        {/* Medication */}
                        <div className="pd-subsection">
                            <h4 className="pd-subsection-title">Medication</h4>
                            <Administration
                            patientId={{ patientId: { _id: patientData.patientId?._id } }}
                            onMedicationChange={handleMedicationChange}
                            medicationRows={treatmentPlan?.medications || []}
                            />
                        </div>

                        {/* Procedure */}
                        <div className="pd-subsection">
                            <h4 className="pd-subsection-title">Procedure</h4>
                            <Procedure
                            patientId={{ patientId: { _id: patientData.patientId?._id } }}
                            onMedicationChange={handleMedicationChange}
                            medicationRows={treatmentPlan?.procedures || []}
                            />
                        </div>
                        </div>
                    )}

                    {/* Section de décharge */}
                    {dischargeData?.dischargeDate && (
                        <div className="pd-section">
                        <div className="pd-section-header">
                            <span className="pd-indicator"></span>
                            <h3 className="pd-section-title">Discharge Details</h3>
                        </div>
                        
                        <div className="pd-discharge">
                            <div className="pd-detail-row">
                            <strong>Status: </strong>
                            <span>{dischargeData.status || 'N/A'}</span>
                            </div>
                            <div className="pd-detail-row">
                            <strong>Discharge Date: </strong>
                            <span>{formatDate(dischargeData.dischargeDate)}</span>
                            </div>
                            <div className="pd-detail-row">
                            <strong>Type: </strong>
                            <span>{dischargeData.dischargeType || 'N/A'}</span>
                            </div>
                            <div className="pd-detail-row">
                            <strong>Reason: </strong>
                            <span>{dischargeData.dischargeReason || 'N/A'}</span>
                            </div>
                            <div className="pd-detail-row">
                            <strong>Health Status: </strong>
                            <span>{dischargeData.healthStatus || 'N/A'}</span>
                            </div>
                            <div className="pd-detail-row">
                            <strong>Recommendations: </strong>
                            <span>{dischargeData.recommendations || 'N/A'}</span>
                            </div>
                            <div className="pd-detail-row">
                            <strong>Discharged By: </strong>
                            <span>
                                {dischargeData.dischargedBy?.lastname || ''} {dischargeData.dischargedBy?.firstname || 'N/A'}
                            </span>
                            </div>
                            <div className="pd-detail-row">
                            <strong>Payment Status: </strong>
                            <span>{dischargeData.paymentStatus ? 'Paid' : 'Pending'}</span>
                            </div>
                        </div>
                        </div>
                    )}
            </div>
           </>
   
       );
   }

export default SuiviPostSortie;
